export const allowedPrice = {
  min: 0,
  max: 100000,
};
